module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button class="toggle-email-mode btn btn-grey">Enable Email Mode</button>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/editorMoreMenu/ToggleEmailModeView.tpl
// module id = 2921
// module chunks = 0